export const stagesCardsData = [
  { title: 'Отбор', text: '3 этапа: проверка английского, интервью с рекрутером и руководителем' },
  { title: 'Старт', text: 'Вводное обучение и погружение в бизнес-процессы' },
  { title: 'Работа в командах', text: 'Первые реальные задачи под наставничеством топ‑менеджеров' },
  {
    title: 'Менторские сессии',
    text: 'Регулярная обратная связь от руководителей и разбор решений',
  },
  {
    title: 'Проектная работа',
    text: 'Ведёшь задачи и ресурсы, формируешь и защищаешь решения перед руководством',
  },
  { title: 'Оценка', text: 'Твоё развитие оценивается честно, с разбором сильных и слабых сторон' },
  { title: 'Предложение о работе', text: 'Оплачиваемая роль при успешном прохождении' },
].map((cardData, i, array) => ({
  ...cardData,
  cardIndex: i + 1,
  amountOfCards: array.length,
}));
